import { cloneNested } from '@/helpers/helpers'

const userModel = {
  status: true,
  password: '',
  teamLoginOnly: false,
  roles: [],
  hourlySalaryGross: 0.00,
  hourlySalaryForReadinessGross: 0.00,
  defaultTeamDefinitionIds: [],
  shiftPriority: 0,
  employmentForm: null,
}
export default {
  userEdited: cloneNested(userModel),
  emptyUser: cloneNested(userModel),
  users: [],
  drivers: [],
  paramedics: [],
  medicineDoctors: [],
}
